export const validateStrategyName = (name: string): string | null => {
    // Only allow alphanumeric characters, spaces, hyphens, underscores, and periods
    const validPattern = /^[a-zA-Z0-9\s._-]*$/;

    if (!validPattern.test(name)) {
        return 'Name can only contain letters, numbers, spaces, hyphens, underscores, and periods';
    }
    return null;
};
